import { Injectable } from '@angular/core';
import { functionalForms, functionalFormsDecay } from '@models/functional-form';

@Injectable({
  providedIn: 'root'
})
export class FunctionalFormService {
  constructor() {}

  public getFunctionalForms() {
    return functionalForms.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
  }

  public getFunctionalFormsForDecay() {
    return functionalFormsDecay.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
  }
}
